import PropTypes from 'prop-types';

export default function ColorfulSpinner({ size = 35 }) {
  return (
    <svg
      className="spinner"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="path"
        fill="none"
        strokeWidth="6"
        strokeLinecap="round"
        cx="33"
        cy="33"
        r="30"
      />
    </svg>
  );
}

ColorfulSpinner.propTypes = {
  size: PropTypes.number
};
